module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.lowResUrl) ? _c('div', {
    staticClass: "backgroundImage",
    style: (_vm.styleObject)
  }) : _c('BlurryImage', {
    attrs: {
      "lowResSrc": '/static/img/' + _vm.lowResUrl,
      "hiResSrc": '/static/img/' + _vm.url,
      "type": "background"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4817f973", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4817f973"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackgroundImage.vue
// module id = 774
// module chunks = 3